module.exports = __webpack_public_path__ + "static/media/chunjie.d805edc5.jpg";